import { useMsal } from '@azure/msal-react';

export const useCurrentUserMpId = (): string => {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts.at(0);
  return String(account?.idTokenClaims?.onpremisesuserprincipalname ?? '');
};
